import { Star } from "lucide-react";

export const StarRating = ({ value, size = 16, className = "" }) => (
  <span className={`inline-flex items-center gap-0.5 ${className}`} aria-label={`${value} out of 5 stars`}>
    {[1, 2, 3, 4, 5].map((n) => (
      <Star
        key={n}
        size={size}
        className={n <= value ? "fill-spark-yellow text-spark-yellow" : "text-spark-line"}
        strokeWidth={1.5}
      />
    ))}
  </span>
);

export const StarPicker = ({ value, onChange, size = 28 }) => (
  <div className="inline-flex items-center gap-1.5" role="radiogroup">
    {[1, 2, 3, 4, 5].map((n) => (
      <button
        key={n}
        type="button"
        onClick={() => onChange(n)}
        aria-label={`${n} stars`}
        className="transition-transform hover:scale-110 focus:outline-none focus:ring-2 focus:ring-spark-yellow rounded"
        data-testid={`rating-star-${n}`}
      >
        <Star
          size={size}
          className={n <= value ? "fill-spark-yellow text-spark-yellow" : "text-spark-line"}
          strokeWidth={1.5}
        />
      </button>
    ))}
  </div>
);
